import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { useStringDataContext } from "../context"
import FilterIcon from "../components/icon/filter"

const StringDataComponent = ({
  // stringMain,
  // stringCross,
  brand,
  material,
  // series,
  // size,
  // balance,
  // year,
}) => {
  const afid = process.env.GATSBY_MERCARI_AFID
  const data = useStringDataContext()
  const strings = data.allMdx.nodes

  const getUniqueSortedValues = key =>
    [
      ...new Set(
        strings.map(({ frontmatter }) => frontmatter[key]).filter(Boolean)
      ),
    ].sort((a, b) => a - b)

  // ユニークなブランド一覧を取得
  const brands = getUniqueSortedValues("brand")
  const materials = getUniqueSortedValues("material")

  // フィルター用のstate
  const [selectedBrands, setSelectedBrands] = useState([])
  const [selectedMaterials, setSelectedMaterials] = useState([])
  const [sortConfig, setSortConfig] = useState({ key: "jp", direction: "desc" })
  const [isFilterVisible, setIsFilterVisible] = useState(false)

  useEffect(() => {
    if (brand) {
      setSelectedBrands([brand])
    }
    if (material) {
      setSelectedMaterials(material)
    }
  }, [brand, material])

  const handleBrandChange = brand => {
    setSelectedBrands(
      prevSelected =>
        prevSelected.includes(brand)
          ? prevSelected.filter(b => b !== brand) // すでに選択されていたら削除
          : [...prevSelected, brand] // 未選択なら追加
    )
  }

  const handleMaterialChange = material => {
    setSelectedMaterials(
      prevSelected =>
        prevSelected.includes(material)
          ? prevSelected.filter(b => b !== material) // すでに選択されていたら削除
          : [...prevSelected, material] // 未選択なら追加
    )
  }

  const filteredStrings = strings.filter(({ frontmatter: string }) => {
    const brandMatch =
      selectedBrands.length > 0 ? selectedBrands.includes(string.brand) : true
    const materialMatch =
      selectedMaterials.length > 0
        ? selectedMaterials.includes(string.material)
        : true

    return brandMatch && materialMatch
  })

  // ソート処理
  const sortedStrings = [...filteredStrings].sort((a, b) => {
    if (!sortConfig.key) return 0

    let aValue = a.frontmatter[sortConfig.key] || ""
    let bValue = b.frontmatter[sortConfig.key] || ""

    if (typeof aValue === "number" && typeof bValue === "number") {
      return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue
    }

    return sortConfig.direction === "asc"
      ? String(aValue).localeCompare(String(bValue), "ja")
      : String(bValue).localeCompare(String(aValue), "ja")
  })

  const handleSort = (key, sortable) => {
    if (!sortable) return // ソート不可の列は処理しない
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }))
  }

  const openFilter = () => {
    setIsFilterVisible(true)
  }

  const closeFilter = () => {
    setIsFilterVisible(false)
  }

  const FilterComponent = () => {
    return (
      <div className={`filter-container`}>
        <div className="racket-num">{sortedStrings.length + `件ヒット`}</div>
        <div className="mt-2">
          ブランド
          <div className="filter-label-wrap">
            {brands.map(brand => (
              <label
                className={`filter-label ${
                  selectedBrands.includes(brand) ? "selected" : ""
                }`}
                key={brand}
              >
                <input
                  type="checkbox"
                  value={brand}
                  checked={selectedBrands.includes(brand)}
                  onChange={() => handleBrandChange(brand)}
                  style={{ display: "none" }}
                />
                {brand}
              </label>
            ))}
          </div>
        </div>
        <div className="mt-2">
          種類
          <div className="filter-label-wrap">
            {materials.map(material => (
              <label
                className={`filter-label ${
                  selectedMaterials.includes(material) ? "selected" : ""
                }`}
                key={material}
              >
                <input
                  type="checkbox"
                  value={material}
                  checked={selectedMaterials.includes(material)}
                  onChange={() => handleMaterialChange(material)}
                  style={{ display: "none" }}
                />
                {material}
              </label>
            ))}
          </div>
        </div>
        <div className="text-center mt-6">
          <button className="search-button" onClick={() => closeFilter()}>
            検索する
          </button>
        </div>
      </div>
    )
  }

  return (
    <>
      {/* オーバーレイ (サイドバーが開いたときのみ表示) */}
      {isFilterVisible && (
        <div
          className="filter-overlay"
          onClick={() => setIsFilterVisible(false)} // 背景クリックで閉じる
        ></div>
      )}
      {isFilterVisible && (
        <div className="filter-sp">
          <FilterComponent />
        </div>
      )}
      {/* <div className="racket-wrap"> */}
      <p className="racket-attention">※横スクロールできます</p>
      <p className="racket-attention">
        ※他のブランドも作成中です(少々お待ちください)
      </p>
      <div className="racket-container">
        {/* スマホ用の検索ボタン */}
        <div className="search-button-wrap">
          <div className="racket-num">{sortedStrings.length + `件ヒット`}</div>
          <button className="search-button" onClick={() => openFilter()}>
            <FilterIcon />
            絞り込み
          </button>
        </div>
        <div className="filter-pc">
          <FilterComponent />
        </div>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                {[
                  { key: "jp", label: "商品名", sortable: true },
                  { key: "price", label: "価格", sortable: false },
                  { key: "brand", label: "ブランド", sortable: true },
                  { key: "material", label: "種類", sortable: false },
                  { key: "thickness", label: "太さ", sortable: false },
                  { key: "colors", label: "色", sortable: false },
                  { key: "technologies", label: "技術", sortable: false },
                  { key: "explanation", label: "説明", sortable: false },
                  { key: "link", label: "公式", sortable: false },
                ].map(({ key, label, sortable }) => (
                  <th
                    key={key}
                    onClick={() => handleSort(key, sortable)}
                    style={{ cursor: sortable ? "pointer" : "default" }}
                  >
                    {label}
                    {sortable && sortConfig.key === key
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedStrings.map(({ frontmatter: string, fields }, index) => (
                <tr key={string.name + index}>
                  <td className="racket-name">
                    <Link to={fields.slug}>
                      {string.jp}
                      <br />({string.name})
                      {string.date ? (
                        <>
                          <br />⭐
                        </>
                      ) : null}
                    </Link>
                  </td>
                  <td>
                    {string.amazon ? (
                      <a
                        className="poppotennis-media__btn __orange racket_price_btn"
                        style={{}}
                        href={string.amazon}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Amazon
                      </a>
                    ) : (
                      ""
                    )}
                    {string.rakuten ? (
                      <a
                        className="poppotennis-media__btn __red racket_price_btn"
                        href={string.rakuten}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        楽天市場
                      </a>
                    ) : (
                      ""
                    )}
                    <a
                      className="poppotennis-media__btn __mercari racket_price_btn"
                      href={`https://jp.mercari.com/search?keyword=${string.brand} ${string.name} テニス&order=desc&sort=score&afid=${afid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      メルカリ
                    </a>
                  </td>
                  <td>{string.brand}</td>
                  <td>{string.material}</td>
                  <td>
                    {string.thickness.map(s => (
                      <div key={`${string.name} ${s}`}>{s} </div>
                    ))}
                  </td>
                  <td>
                    {string.colors.map(c => (
                      <div key={`${string.name} ${c}`}>{c} </div>
                    ))}
                  </td>
                  <td className="tooltip-container">
                    {string.technologies?.length > 0 ? (
                      <span className="tooltip-trigger">
                        {string.technologies[0]}
                        {string.technologies.length > 1 && " ..."}
                        <span
                          className={`tooltip-content ${
                            index <= 5 ? "tooltip-bottom" : "tooltip-top"
                          }`}
                        >
                          <ul>
                            {string.technologies.map((t, j) => (
                              <li key={`tech${index}/${j}`}>{t}</li>
                            ))}
                          </ul>
                        </span>
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>
                    <div
                      style={{
                        maxWidth: "20em",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 4,
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {string.explanation}
                    </div>
                  </td>
                  <td>
                    {string.url ? (
                      <a
                        href={string.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        リンク
                      </a>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-sm font-bold">
            誤表記や追加して欲しいもののご要望ありましたらお問い合わせからお気軽にご連絡ください。
          </div>
          <a
            href="https://forms.gle/Krop9vVJM94nbAk4A"
            target="_blank"
            rel="noopener noreferrer"
          >
            お問い合わせ
          </a>
        </div>
      </div>
      {/* </div> */}
    </>
  )
}

export default StringDataComponent
